export default __webpack_public_path__ + "static/design-9a6552c338ee9498978917932a066992.png";